import { useClientState } from "state/useClientState";
import { useEffect } from "react";
import useClientAmplify from "./useClientAmplify";
import { useMiniappReq } from "state/useMiniappReq";
import { getDB } from "InitiateRxdb";
import { useTokenCredentials } from "state/useTokenCredentials";
import { useAuthContext } from "context/AuthContext";

export default function useRxdbMiniappReq() {
    const { getOutletId } = useAuthContext();
    const [clientAmplify] = useClientAmplify();

    const { getClient, updateClient } = useClientState((state) => ({
        getClient: state.getClient,
        updateClient: state.updateClient,
    }));

    const { getTokenCredentials } = useTokenCredentials((state) => ({
        getTokenCredentials: state.getTokenCredentials,
    }));

    const { updateMiniappReq, getMiniappReqId } = useMiniappReq((state) => ({
        updateMiniappReq: state.updateMiniappReq,
        getMiniappReqId: state.getMiniappReqId,
    }));

    const subscribeMiniappReq = async () => {
        const reqId = getMiniappReqId();
        const timeout = setTimeout(() => {
            updateMiniappReq('not_updated');
        }, 20000);

        const db = await getDB();
        const obj = {
            status: "updated",
            partition: getOutletId(),
            id: reqId,
        }
        console.log(obj);
        
        const query = db.miniapprequests.findOne(
            {
                selector: obj
            }).sort({ _rev: "desc" })

        const querySub = await query.$.subscribe((doc) => {
            console.log('subscribe miniapp req-----', doc?.status);

            if (doc) {
                updateMiniappReq(doc.status)
                clearTimeout(timeout);
                return;
            }
        });

        return () => {
            querySub.unsubscribe()
        }
    }

    useEffect(() => {
        if (!getClient().graphql) {
            const client = clientAmplify(getTokenCredentials().access_token)
            updateClient(client);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getClient()]);

    return [subscribeMiniappReq];
}
